module.exports = __webpack_public_path__ + "static/img/jx-mini.ee37a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx-mini.jpg
// module id = BMSp
// module chunks = 16